import { Button, Card, Container, Form } from 'react-bootstrap'
import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react-lite'
import PhoneInput from 'react-phone-input-2'
import FooterNew from '../components/Footer'
import { useStore } from '../../app/stores/store'
import ErrorMessage from '../components/ErrorMessage'
import ResendConfirmEmail from './ResendConfirmEmail'
import { history } from '../..'
import 'react-phone-input-2/lib/material.css'
import Export from '../components/export/Export'

function Register() {
  const INITIAL_VALUE = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmpassword: '',
    phoneNumber: '',
    language: '',
    gender: 0,
  }
  const [showPassword, setShowPassword] = useState(false)
  const [regUser, setRegUser] = useState(INITIAL_VALUE)
  const { userStore } = useStore()
  const { register, loadingButton } = userStore
  const [error, setError] = useState('')
  const { t, i18n } = useTranslation()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const auctionId = params.get('auctionId')
  const token = params.get('token')
  const validateEmail = params.get('validateEmail')

  const queryParams = {
    auctionId: auctionId!,
    token: token!,
    validateEmail: validateEmail!,
  }

  const genderOptions = Export()

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }

  useEffect(() => {
    scrollToTop()
  }, [])

  function handleRegister(e: any) {
    e.preventDefault()
    if (regUser.password !== regUser.confirmpassword) {
      setError(t('passwords_not_matching')!)
    } else if (regUser.phoneNumber.length <= 2) {
      setError(t('err_tel')!)
    } else {
      regUser.language = i18n.resolvedLanguage || 'de'
      setError('')
      register(regUser)
        .then(() => {
          setRegUser(INITIAL_VALUE)
          setError('')
          if (auctionId) {
            history.push({
              pathname: `/auctions/${auctionId}`,
              search: new URLSearchParams(queryParams).toString(),
            })
          }
          else {
            history.push({
              pathname: '/login',
            })
          }
        })
        .catch((err) => console.log(err))
    }
  }

  function handleInputChangeRegister(e: any) {
    const { name, value } = e.target
    setRegUser({ ...regUser, [name]: value })
    setError('')
  }

  const handlePhoneChange = (value: string) => {
    setRegUser({ ...regUser, phoneNumber: value })
    setError('')
  }

  const formData = [
    {
      label: t('firstName'),
      className: 'card-input-style form-control-spacing',
      type: 'text',
      name: 'firstName',
      placeholder: 'John',
      value: regUser.firstName,
      required: true,
    },

    {
      label: t('lastName'),
      className: 'card-input-style form-control-spacing',
      type: 'text',
      name: 'lastName',
      placeholder: 'Doe',
      value: regUser.lastName,
      required: true,
    },
    {
      label: t('gender'),
      className: 'card-input-style form-control-spacing',
      type: 'select',
      name: 'gender',
      placeholder: 'Select Gender',
      value: regUser.gender,
      required: true,
      options: genderOptions,
    },
    {
      label: t('email'),
      className: 'card-input-style form-control-spacing',
      type: 'text',
      name: 'email',
      placeholder: 'example@gmail.com',
      value: regUser.email,
      required: true,
    },
    {
      label: t('phoneNumber'),
      component: (
        <PhoneInput
          inputStyle={{ width: '100%' }}
          inputClass='phone-input-style form-control-spacing'
          country='ch'
          placeholder='0 123 456 789'
          enableSearch
          specialLabel=''
          value={regUser.phoneNumber}
          onChange={handlePhoneChange}
        />
      ),
    },
    {
      label: t('password'),
      className: 'card-input-style form-control-spacing',
      type: showPassword ? 'text' : 'password',
      name: 'password',
      placeholder: '*********',
      value: regUser.password,
      required: true,
    },
    {
      label: t('confirmpassword'),
      className: 'card-input-style',
      type: showPassword ? 'text' : 'password',
      name: 'confirmpassword',
      placeholder: '*********',
      value: regUser.confirmpassword,
      required: true,
    },
  ]

  const loginData = [
    {
      title: t('log_in'),
      onClick: () => setError(''),
      to: auctionId
        ? {
            pathname: '/login',
            search: new URLSearchParams(queryParams).toString(),
          }
        : '/login',
    },
  ]

  return (
    <>
      <Container fluid className='card-center card-background'>
        <Card className='newFont prevent-select card-shadow login-card-size'>
          <Card.Header className='bg-white'>
            <h1 className='login-card-title'>{t('create_acc')}</h1>
          </Card.Header>
          <Card.Body className='card-padding'>
            <Form onSubmit={handleRegister}>
              <Form.Group className='mb-3 card-font-size '>
                {formData.map((field, index) => (
                  <div key={index}>
                    <Form.Label className='login-p'>{field.label}</Form.Label>
                    {field.component ? (
                      field.component
                    ) : field.type === 'select' ? (
                      <Form.Control
                        as='select'
                        className={field.className}
                        name={field.name}
                        required={field.required}
                        value={field.value}
                        onChange={handleInputChangeRegister}
                      >
                        <option value=''>{field.placeholder}</option>
                        {field.options!.map((option, optionIndex) => (
                          <option key={optionIndex} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Form.Control>
                    ) : (
                      <Form.Control
                        className={field.className}
                        type={field.type}
                        name={field.name}
                        placeholder={field.placeholder}
                        required={field.required}
                        value={field.value}
                        onChange={handleInputChangeRegister}
                      />
                    )}
                  </div>
                ))}
              </Form.Group>
              <Form.Group className='d-flex text-black pt-3 card-font-size'>
                <label
                  onClick={() => setShowPassword(!showPassword)}
                  className='d-flex gap-2 align-items-center'
                >
                  <span
                    className={`text-black mb-0 pointer-cursor ${
                      showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'
                    }`}
                  />
                  {t('show_password')}
                </label>
              </Form.Group>
              {error && <ErrorMessage text={t(error)} setError={() => setError('')} />}
              <Button
                type='submit'
                variant='light'
                className='mt-5 card-login-button'
                disabled={loadingButton}
              >
                {t('register')}
              </Button>
              <Form.Group
                style={{ paddingTop: '25px' }}
                className='d-flex text-center justify-content-center align-items-center gap-2 text-black card-font-size'
              >
                <Form.Label>{t('already_have_acc')}?</Form.Label>

                <Form.Label className='card-passwordUnderline text-center greenColor'>
                  {loginData.map((data, index) => (
                    <Link key={index} onClick={data.onClick} to={data.to}>
                      {data.title}
                    </Link>
                  ))}
                </Form.Label>
              </Form.Group>
            </Form>
          </Card.Body>
        </Card>
      </Container>
      <ResendConfirmEmail />
      <FooterNew />
    </>
  )
}
export default observer(Register)
